import DropdownButton from "@Generic/buttons/DropdownButton";
import CheckOrderInputContainer from "@CheckOrder/components/MainSection/CheckOrderInputContainer";
import React from "react";
import {DimensionOption, VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";
import IconLengthIndicator from "@Icons/vehicle/IconLengthIndicator";
import Translation from "@Translation/components/Translation";
import useGetSelectedVehicleLengthLabel
    from "@CheckOrder/features/addons/features/jadrolinija/features/vehicleAdditionalLength/hooks/useGetSelectedVehicleLengthLabel";
import checkActiveOptionType from "@CheckOrder/features/addons/features/jadrolinija/functions/checkActiveOptionType";

interface VehicleAdditionalLengthProps {
    activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }
    setLength: (value: DimensionOption) => void,
    additionalLength: DimensionOption | null,
}

function VehicleAdditionalLength(props: VehicleAdditionalLengthProps) {
    const {
        activeOption,
        setLength,
        additionalLength,
    } = props

    const {getActiveLabel} = useGetSelectedVehicleLengthLabel(activeOption, additionalLength)
    const {isMotorcycle} = checkActiveOptionType()

    return (
        <CheckOrderInputContainer
            label={(isMotorcycle(activeOption) ? (
                    <Translation translationKey="check_order.addons.JADL.vehicle.length.title"/>
                ) : (
                    <Translation
                        translationKey="check_order.addons.JADL.vehicle.additional_length.title"
                    />
                )
            )}
            className="vehicle__additional-length"
        >
            {!isMotorcycle(activeOption) && (
                <Translation translationKey="check_order.addons.JADL.vehicle.additional_length.description"/>
            )}
            <DropdownButton
                label={getActiveLabel()}
                baseClass="gb--select"
                cssButtonClass="gb--select-dropdown"
            >
                {activeOption.activeGroup.lengthOptions.map((option) => (
                    <button
                        type="button"
                        key={option.value}
                        value={option.value}
                        onClick={() => setLength(option)}
                        className="gb--select__option full-width"
                    >
                        <IconLengthIndicator/>
                        {option.label}
                    </button>
                ))}
            </DropdownButton>
        </CheckOrderInputContainer>
    );
}

export default VehicleAdditionalLength